// require('./modules/modernizr');
// require('intersection-observer');

//svg icons
require.context('../../icons', true)
require('svg4everybody')
//

import {getCookie, setCookie, isMob} from '../_helpers';
import {watch} from "./modules/clientWatcher";

//Check safari mob
var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
    isIphone = /(iPhone)/i.test(navigator.userAgent)

if(isSafari && isIphone){
    document.getElementsByTagName('head')[0].innerHTML = '<link href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700;900&display=swap" rel="stylesheet">' + document.getElementsByTagName('head')[0].innerHTML;
    document.getElementsByTagName('body')[0].classList.add('safarimob')
    var safarimob = true;
}else{
    var safarimob = false
}
//

//fonts
import webFontLoader from '../../../node_modules/webfontloader/webfontloader'
if(!safarimob){
    webFontLoader.load({
        google: {
            families: ['Montserrat:400,500,700,800&display=swap&subset=cyrillic']
        }
    })
}
//

//watchers
watch();
//

//forms
import init_ajaxform from './modules/ajaxform';

//lazy images
// import LazyLoad from "vanilla-lazyload";
// global.LazyLoad = LazyLoad
// global.LazyLoad_instance = new LazyLoad({
//     class_loaded: 'lazyloaded',
//     threshold: 1000
// });

//modals
global.bootstrap_modal = require('bootstrap/js/dist/modal');

const $body = document.querySelector('body');
let scrollPosition = 0;

var modals = document.querySelectorAll('.modal');
Array.prototype.forEach.call(modals, function (_modal) {
    _modal.addEventListener('show.bs.modal', function () {
        document.querySelector('html').classList.add('modal-open')

        scrollPosition = window.pageYOffset;
        $body.style.overflow = 'hidden';
        $body.style.position = 'fixed';
        $body.style.top = `-${scrollPosition}px`;
        $body.style.width = '100%';
    })
    _modal.addEventListener('hide.bs.modal', function () {
        document.querySelector('html').classList.remove('modal-open')

        $body.style.removeProperty('overflow');
        $body.style.removeProperty('position');
        $body.style.removeProperty('top');
        $body.style.removeProperty('width');
        window.scrollTo(0, scrollPosition);
    })
})

//mask
import MaskInput from 'mask-input';

var phone_mask_inputs = document.querySelectorAll('input.phone_mask');
Array.prototype.forEach.call(phone_mask_inputs, function (input) {
    new MaskInput(input, {
        mask: '+7(000) 000-00-000',
        alwaysShowMask: true,
        maskChar: '_',
    });

    input.addEventListener('click', () => {
        if (input.value == '+7(___) ___-__-___') {
            setSelectionRange(input, 0);
        }
    });
});

function setSelectionRange(input, selectionStart, selectionEnd) {
    if (input.setSelectionRange) {
        input.focus();
        input.setSelectionRange(selectionStart, selectionEnd);
    } else if (input.createTextRange) {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveEnd('character', selectionEnd);
        range.moveStart('character', selectionStart);
        range.select();
    }
}

//
var inputs_box = document.querySelectorAll('.input_box')
if (inputs_box.length) {
    Array.prototype.forEach.call(inputs_box, function (box) {
        var input = box.querySelector('.input')

        if (input) {
            input.addEventListener('keyup', _keyup)

            _keyup()

            function _keyup() {
                if (input.value) {
                    box.classList.add('complite')

                    if(input.classList.contains('input_price')){
                        if(input.value){
                            var n = parseInt(input.value.replace(/\D/g,''),10)
                            if(isNaN(n)){
                                input.value = ''
                            }else{
                                input.value = n.toLocaleString()
                            }
                        }else{
                            input.value = ''
                        }
                    }

                } else if (document.activeElement !== input) {
                    box.classList.remove('complite')
                }
            }

            input.addEventListener('focus', () => {
                box.classList.add('complite')
            })
            input.addEventListener('blur', () => {
                if (!input.value) box.classList.remove('complite')
            })

            box.addEventListener('click', () => {
                if (!input.value) {
                    input.focus()
                }
            });

            if(input.classList.contains('text')){

                input.style.boxSizing = 'border-box';
                var offset = input.offsetHeight - input.clientHeight;
                input.addEventListener('input', function (event) {
                    event.target.style.height = 'auto';
                    event.target.style.height = event.target.scrollHeight + offset + 4 + 'px';
                });
                input.removeAttribute('data-autoresize');

            }
        }

    })
}
//

//journal
if(!isMob()){
    var journal = document.querySelector('.journal');
    if(journal){
        journal.querySelector('.close').addEventListener('click', () =>{
            journal.classList.remove('show')
        })
        setTimeout(function () {
            if(!getCookie('getjournal') && (typeof journal_reject_auto_open == 'undefined')){
                setCookie('getjournal', 'wasshow', 2)
                journal.classList.add('show')
            }
        }, 13000);
    }
}else{
    var modal_whatsup_chat = document.getElementById('whatsupChatModal')
    if(modal_whatsup_chat){
        var modal_whatsup_chat_instance = new bootstrap_modal(modal_whatsup_chat)

        setTimeout(function () {
            if(!getCookie('getwhatsupchat') && (typeof whatsup_chat_reject_auto_open == 'undefined')){
                setCookie('getwhatsupchat', 'wasshow', 2)
                modal_whatsup_chat_instance.show()
            }
        }, 8000);
    }
}

init_ajaxform('.ajax_form:not(.activate)');
